import axios from 'axios';
import authHeader from './auth-header';

class UserService {
    getUser() {
        return axios.get(window.api_url + "/api/auth/user", {headers: authHeader()});
    }

    getUserById(id) {
        return axios.get(window.api_url + "/api/auth/user/" + id, {headers: authHeader()});
    }

    isAdmin() {
        return axios.get(window.api_url + "/api/auth/isAdmin", {headers: authHeader()});
    }

    getRating(id) {
        return axios.get(window.api_url + "/api/auth/rating/" + id, {headers: authHeader()});
    }

    getRatings(amount) {
        return axios.get(window.api_url + "/api/auth/ratings?amount=" + amount, {headers: authHeader()});
    }

    getGameRatings(id) {
        return axios.get(window.api_url + "/api/game/" + id + "/ratings", {headers: authHeader()});
    }

    getRatingsById(id, amount) {
        return axios.get(window.api_url + "/api/auth/user/" + id + "/games/" + amount, {headers: authHeader()});
    }

    getFriends() {
        return axios.get(window.api_url + "/api/auth/friends", {headers: authHeader()});
    }

    getFriendsFromUser(id) {
        return axios.get(window.api_url + "/api/auth/" + id + "/friends", {headers: authHeader()});
    }

    edit(user) {
        return axios.post(window.api_url + '/api/auth/user', user, {headers: authHeader()});
    }

    addFriend(email) {
        let formData = new FormData();
        formData.append('email', email);
        return axios.post(window.api_url + "/api/auth/friends/add", formData, {headers: authHeader()});
    }

    removeFriend(email) {
        let formData = new FormData();
        formData.append('email', email);
        return axios.post(window.api_url + "/api/auth/friends/remove", formData, {headers: authHeader()});
    }

    getRecentlyPlayed(amount){
        return axios.get(window.api_url + "/api/games/recent/" + amount, {headers: authHeader()});
    }

    getPopular(days, amount){
        return axios.get(window.api_url + "/api/games/popular/" + days + "/" + amount, {headers: authHeader()});
    }

    getRecentlyPlayedByFriends(amount){
        return axios.get(window.api_url + "/api/auth/user/friends/recent/" + amount, {headers: authHeader()});
    }

}

export default new UserService();
